export const homePage = {
  path: '/',
  images: {
    hero: '/hero-pos.webp',
  },
  seoTitle: 'POS System for Restaurants | Cloud Point of Sale | Tillio POS',
  seoDescription:
    'Tillio is a cloud-based POS system for restaurants. Run point of sale, tables, payments, team management, and analytics in one modern platform.',
  hero: {
    title: 'Restaurant POS system built for real service',
    description:
      'Tillio is a cloud-based point of sale system for restaurants—orders, tables, payments, team management, and analytics in one platform. A modern POS system that replaces disconnected tools and old cash registers.',
  },
  pillars: [
    {
      title: 'Run Your Business',
      text: 'POS tools for your daily operations',
      image: '/category-run-business.webp',
      to: '/features/point-of-sale',
    },
    {
      title: 'Engage Customers',
      text: 'Faster service and smoother checkouts',
      image: '/category-engage-customers.webp',
      to: '/features/table-management',
    },
    {
      title: 'Take Payments',
      text: 'Card payments powered by Stripe',
      image: '/category-take-payments.webp',
      to: '/stripe',
    },
    {
      title: 'Manage Finances',
      text: 'Sales insight and reporting',
      image: '/category-manage-finances.webp',
      to: '/features/analytics',
    },
  ],
}
